import Box from '@zenbusiness/zui/Box';
import Skeleton from '@zenbusiness/zui/Skeleton';
import { superstyled } from '@zenbusiness/zui/styles';

const FlexContainer = superstyled({
  tag: Box,
  name: 'ProfileHeaderLoadingState',
  styles: ({ theme }) => ({
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
    flexDirection: 'column'
  })
});

function ProfileHeaderLoadingState() {
  return (
    <FlexContainer
      data-testid="profile-header-loading-outer"
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row'
        }
      })}
    >
      <FlexContainer data-testid="profile-header-loading-entity" sx={{ flexDirection: 'row' }}>
        <Box sx={{ minWidth: '60px' }}>
          <Skeleton role="img" width={60} height={100} />
        </Box>
        <Box>
          <Skeleton role="img" width={200} height={20} />
          <Skeleton role="img" width={100} height={20} />
        </Box>
      </FlexContainer>
      <FlexContainer
        data-testid="profile-header-loading-status"
        sx={(theme) => ({
          [theme.breakpoints.up('lg')]: {
            flexDirection: 'row'
          }
        })}
      >
        <Skeleton role="img" width={200} height={20} />
        <Skeleton role="img" width={200} height={20} />
        <Skeleton role="img" width={200} height={60} />
      </FlexContainer>
    </FlexContainer>
  );
}

export default ProfileHeaderLoadingState;
